<template>
    <div class="w-screen min-h-[100dvh]">
        <div id="popup-modal" tabindex="-1" v-show="isShowError"
            class="fixed top-0 left-0 right-0 z-50 p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[100vh] max-h-full flex items-center justify-center bg-gray-900 bg-opacity-50">
            <div class="relative w-full max-w-md max-h-full">
                <div class="relative bg-white rounded-lg shadow">
                    <div class="p-6 text-center">
                        <svg aria-hidden="true" class="mx-auto mb-4 text-gray-400 w-14 h-14" fill="none"
                            stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        <h3 class="mb-5 text-lg font-normal text-gray-500">
                            {{ $t('Something went wrong') }}.</h3>
                        <button type="button" @click="reload"
                            class="text-white primary_background hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2">
                            {{ $t('Restart session') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>



        <div class="w-screen min-h-[100dvh] flex justify-center align-middle">

            <transition name="slide-fade">
                <div v-if="loadingScreen"
                    class="fixed top-0 left-0 w-full h-[100dvh] flex justify-center items-center z-[100]">
                    <div class="relative max-h-full p-8">
                        <div
                            class="relative bg-white rounded-lg shadow-md md:shadow-2xl duration-300 flex items-center justify-center w-[180px]">
                            <div class="emojiloader"></div>
                        </div>
                    </div>
                </div>
            </transition>


            <transition name="slide-fade">
                <div v-if="!loadingScreen"
                    class="h-full min-h-[calc(100dvh-100px)] md:m-8 w-full flex justify-center items-center">
                    <div class="mobile_top_corners md:hidden"></div>
                    <section
                        class="w-full max-w-7xl h-full max-md:min-h-[100dvh] md:min-h-[calc(100dvh-8rem)] mx-auto p-4 md:p-8 bg-white rounded-t-3xl md:rounded-2xl shadow-2xl"
                        :class="[getAmountOfRooms(setup) > 0 ? 'max-md:pb-[100px]' : '']">
                        <div class="grid md:grid-cols-12 gap-5 md:h-full">
                            <div class="md:col-span-8 md:h-full overflow-hidden">
                                <div class="md:h-full relative">
                                    <div class="mx-auto md3:pr-4 md:h-full">
                                        <div class="md:h-full" v-show.transition="step != '4'">
                                            <!-- Top Navigation -->
                                            <div class="border-b-2 pt-2">
                                                <div class="flex flex-col md:flex-row md:items-center md:justify-between">
                                                    <div class="flex-1">
                                                        <img class="max-h-[100px] max-w-[150px] md:max-h-[150px] md:max-w-[200px] mx-auto md:ml-0"
                                                            :src="this.client_logo" :alt="this.client.name + ' logo'">
                                                    </div>
                                                </div>
                                                <ol v-if="!warning"
                                                    class="flex items-center w-full text-sm font-medium text-center text-gray-500 sm:text-base mt-8 md:px-4 pt-2 pb-4 overflow-x-scroll justify-between">

                                                    <li v-if="!hideUpsells" :class="{ 'primary_color': step >= 1 }"
                                                        class="flex md:w-full items-center sm:after:content-['']  after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10">
                                                        <span @click="step = 1"
                                                            class="flex cursor-pointer items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200">
                                                            <svg v-show="step > 1" aria-hidden="true"
                                                                class="w-4 h-4 mr-2 sm:w-5 sm:h-5" fill="currentColor"
                                                                viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd"
                                                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                                                    clip-rule="evenodd"></path>
                                                            </svg>
                                                            <span v-show="computed_step == 1" class="mr-2">1</span>
                                                            Extra's
                                                        </span>
                                                    </li>

                                                    <li :class="{ 'primary_color': step >= 2 }"
                                                        class="flex  md:w-full items-center sm:after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-200 after:border-1 after:hidden sm:after:inline-block after:mx-6 xl:after:mx-10">
                                                        <span @click="step = 2"
                                                            class="flex cursor-pointer items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200">
                                                            <svg v-show="step > 2" aria-hidden="true"
                                                                class="w-4 h-4 mr-2 sm:w-5 sm:h-5" fill="currentColor"
                                                                viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd"
                                                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                                                    clip-rule="evenodd"></path>
                                                            </svg>
                                                            <span v-if="!hideUpsells" v-show="step <= 2"
                                                                class="mr-2">2</span>
                                                            <span v-else v-show="step <= 2" class="mr-2">1</span>
                                                            {{ $t('personal') }} <span
                                                                class="hidden sm:inline-flex sm:ml-2">{{
                                                                    $t('info') }}</span>
                                                        </span>
                                                    </li>
                                                    <li :class="{ 'primary_color': step >= 3 }" class="items-center">
                                                        <span @click="formValid ? submitBooking() : null"
                                                            class="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200"
                                                            :class="[formValid ? 'cursor-pointer' : 'cursor-not-allowed']">
                                                            <svg v-show="step > 3" aria-hidden="true"
                                                                class="w-4 h-4 mr-2 sm:w-5 sm:h-5" fill="currentColor"
                                                                viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                                <path fill-rule="evenodd"
                                                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                                                    clip-rule="evenodd"></path>
                                                            </svg>
                                                            <span v-if="!hideUpsells" v-show="step <= 3"
                                                                class="mr-2">3</span>
                                                            <span v-else v-show="step <= 3" class="mr-2">2</span>
                                                            {{ getThirdStepName() }}
                                                        </span>
                                                    </li>
                                                </ol>
                                                <div v-else class="mt-8"></div>
                                            </div>
                                            <!-- TOP NAVICATION -->
                                            <!-- Step Content -->

                                            <div class="pt-6 md:pb-4">
                                                <div v-if="computed_step == 1" key=1>
                                                    <h3 v-if="!warning" class="text-lg font-medium mb-5">
                                                        {{ $t('Would you like anything else?') }}
                                                    </h3>
                                                    <h3 v-else class="text-lg font-medium mb-5">
                                                        {{ $t('Not all rooms are available') }}
                                                    </h3>

                                                    <div v-if="warning" class="flex flex-col">
                                                        {{ $t('Unfortunately') }} {{ warning }}

                                                        <button @click="goToRoomSelection()"
                                                            class="w-32 mt-8 focus:outline-none border border-transparent py-2 px-5 rounded-lg shadow-sm text-center text-white font-medium transition duration-300 !opacity-100 hover:shadow-xl primary_background !cursor-pointer hover:scale-105">
                                                            {{ $t('Go back') }}
                                                        </button>
                                                    </div>
                                                    <template v-else v-for="(roomsetup, room_number) in computed_upsells">
                                                        <div v-if="hasOptionalUpsells(roomsetup)"
                                                            v-for="(priceItems, room_id) in roomsetup"
                                                            :class="{ 'p-4 pt-2 border rounded-lg mb-12': upsells.length > 1 || upsells.length > 1 }">
                                                            <h3 class="mb-2 font-medium">{{
                                                                getLocaleRoomName(JSON.parse(rooms)[room_id],
                                                                    $i18n.locale.toUpperCase()) }}</h3>
                                                            <template>
                                                                <ul class="grid w-full gap-6 lg:grid-cols-2 mb-20 md:mb-0">
                                                                    <template v-for="(priceItem, key) in priceItems">
                                                                        <li :data="show = true"
                                                                            v-if="priceItem.type == 1 || priceItem.type == 3">
                                                                            <!-- Eventually add type 5, percentages -->
                                                                            <input type="checkbox"
                                                                                :name="'ups_' + room_id + '_' + priceItem.type + '_' + priceItem.unit + '_' + priceItem.period + '_' + parseInt(priceItem.price) + '_' + key + '_' + room_number"
                                                                                :id="'ups_' + room_id + '_' + priceItem.type + '_' + priceItem.unit + '_' + priceItem.period + '_' + parseInt(priceItem.price) + '_' + key + '_' + room_number"
                                                                                :ref="'ups_' + room_id + '_' + priceItem.type + '_' + priceItem.unit + '_' + priceItem.period + '_' + parseInt(priceItem.price) + '_' + key + '_' + room_number"
                                                                                :value="priceItem.description.EN"
                                                                                class="hidden peer"
                                                                                v-model="priceItem.check">
                                                                            <label
                                                                                :for="'ups_' + room_id + '_' + priceItem.type + '_' + priceItem.unit + '_' + priceItem.period + '_' + parseInt(priceItem.price) + '_' + key + '_' + room_number"
                                                                                @click="calculateTotal(priceItem, key, room_id, room_number, null, null);"
                                                                                :class="[priceItem.description2.EN ? 'justify-between' : 'justify-center', priceItem.type == 3 && priceItem.check ? 'pb-2' : '', priceItem.check ? 'border-2' : '']"
                                                                                class="h-full inline-flex items-center flex-col w-full text-gray-500 bg-white border border-gray-200 rounded-lg cursor-pointer peer-checked peer-checked:border-primary peer-checked:text-primary hover:text-gray-600 hover:bg-gray-100">
                                                                                <div
                                                                                    class=" inline-flex items-center justify-between w-full h-full">
                                                                                    <div class="block p-5 pr-2">
                                                                                        <div
                                                                                            class="w-full text-lg font-semibold select-none">
                                                                                            {{
                                                                                                getUpsellNameWithoutMax(priceItem.description.EN)
                                                                                            }}</div>
                                                                                        <div v-if="priceItem.description2.EN"
                                                                                            class="w-full select-none leading-5 text-sm" v-html="priceItem.description2.EN">
                                                                                        </div>
                                                                                    </div>
                                                                                    <vue-load-image
                                                                                        class="max-w-32 h-full px-3 flex justify-center"
                                                                                        v-if="priceItem.image && priceItem.image != 0 && getRoomImage(room_id)">
                                                                                        <img slot="image"
                                                                                            :src="mipmap(getRoomImage(room_id), 300)"
                                                                                            class="max-h-32 w-full rounded-t-lg object-contain select-none"
                                                                                            :alt="priceItem.description.EN">
                                                                                        <div slot="preloader"
                                                                                            class="flex items-center justify-center w-full max-h-32 bg-gray-300 rounded-t-lg animate-pulse">
                                                                                            <svg class="w-12 h-12 text-gray-200"
                                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                                aria-hidden="true"
                                                                                                fill="currentColor"
                                                                                                viewBox="0 0 640 512">
                                                                                                <path
                                                                                                    d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
                                                                                            </svg>
                                                                                        </div>
                                                                                    </vue-load-image>
                                                                                    <div class="p-5 flex flex-col items-end h-full justify-center"
                                                                                        :class="{ 'justify-between': priceItem.type == 3 && priceItem.check }">
                                                                                        <div
                                                                                            class="text-lg price select-none text-right">
                                                                                            <span class="font-semibold"
                                                                                                v-if="priceItem.price == 0">Free!</span>
                                                                                            <span v-else
                                                                                                class="font-semibold">{{
                                                                                                    toCurrency(priceItem.price)
                                                                                                }}</span>
                                                                                            <div class="-mt-2 mb-2"
                                                                                                v-if="priceItem.price != 0">
                                                                                                <small
                                                                                                    v-if="priceItem.unit == 1"
                                                                                                    class="w-full select-none leading-5 small text-right">
                                                                                                    {{ $t('Per person') }}
                                                                                                </small>
                                                                                                <small
                                                                                                    v-else-if="priceItem.unit == 2"
                                                                                                    class="w-full select-none leading-5 small text-right">
                                                                                                    {{ $t('Per adult') }}
                                                                                                </small>
                                                                                                <small
                                                                                                    v-else-if="priceItem.unit == 3"
                                                                                                    class="w-full select-none leading-5 small text-right">
                                                                                                    {{ $t('Per child') }}
                                                                                                </small>
                                                                                                <small
                                                                                                    v-if="priceItem.period == 1"
                                                                                                    class="w-full select-none leading-5 small text-right">
                                                                                                    {{ $t('daily') }}
                                                                                                </small>
                                                                                                <small
                                                                                                    v-else-if="priceItem.period == 4"
                                                                                                    class="w-full select-none leading-5 small text-right">
                                                                                                    {{ $t('daily incl. checkout') }}
                                                                                                </small>
                                                                                                <small
                                                                                                    v-else-if="priceItem.period == 2"
                                                                                                    class="w-full select-none leading-5 small text-right">
                                                                                                    {{ $t('weekly') }}
                                                                                                </small>
                                                                                            </div>
                                                                                        </div>

                                                                                    </div>
                                                                                </div>

                                                                                <div v-if="priceItem.type == 3 && priceItem.check"
                                                                                    class="pb-5">
                                                                                    <div
                                                                                        class="custom-number-input h-10 w-32">
                                                                                        <div
                                                                                            class="flex flex-row h-10 w-full rounded-lg relative bg-transparent mt-1">
                                                                                            <button
                                                                                                @click.stop="calculateTotal(priceItem, key, room_id, room_number, null, 'min');"
                                                                                                class=" bg-gray-200 text-gray-600 hover:text-gray-700 hover:bg-gray-400 h-full w-20 rounded-l cursor-pointer outline-none select-none">
                                                                                                <span
                                                                                                    class="m-auto text-2xl font-thin">−</span>
                                                                                            </button>
                                                                                            <input type="number" readonly
                                                                                                class="outline-none focus:ring-0 select-none border-none focus:outline-none text-center w-full bg-gray-200 font-semibold text-md hover:text-black focus:text-black  md:text-basecursor-default flex items-center text-gray-700  outline-none"
                                                                                                name="custom-input-number" :max="getMaxUpsellAmount(priceItem.description.EN)" min="0"
                                                                                                :value="priceItem.amount ? priceItem.amount : 0" />
                                                                                            <button
                                                                                                @click.stop="getMaxUpsellAmount(priceItem.description.EN) > priceItem.amount ? calculateTotal(priceItem, key, room_id, room_number, null, 'plus') : null;"
                                                                                                class="bg-gray-200 text-gray-600 hover:text-gray-700 hover:bg-gray-400 h-full w-20 rounded-r cursor-pointer select-none">
                                                                                                <span
                                                                                                    class="m-auto text-2xl font-thin">+</span>
                                                                                            </button>
                                                                                        </div>
                                                                                        <small v-if="getMaxUpsellAmount(priceItem.description.EN)" class="w-100 block text-center leading-5 whitespace-nowrap">{{ $t("maximum of") }} {{ getMaxUpsellAmount(priceItem.description.EN) }} {{ $t("items") }}</small>
                                                                                    </div>
                                                                                </div>
                                                                            </label>
                                                                        </li>
                                                                    </template>
                                                                </ul>
                                                            </template>
                                                        </div>
                                                    </template>
                                                </div>
                                                <div v-else-if="computed_step == 2" key=2>
                                                    <div class="-mx-3 flex flex-wrap">
                                                        <div class="w-full px-3 sm:w-1/2">
                                                            <div class="mb-5">
                                                                <label for="first_name"
                                                                    class="mb-3 block text-base font-medium text-gray-600">
                                                                    {{ $t('First Name') }}*
                                                                </label>
                                                                <input type="text" name="first_name" id="first_name"
                                                                    :placeholder="$t('First Name')"
                                                                    v-model="formData.first_name" required
                                                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focusBorder focus:shadow-md" />
                                                            </div>
                                                        </div>
                                                        <div class="w-full px-3 sm:w-1/2">
                                                            <div class="mb-5">
                                                                <label for="last_name"
                                                                    class="mb-3 block text-base font-medium text-gray-600">
                                                                    {{ $t('Last Name') }}*
                                                                </label>
                                                                <input type="text" name="last_name" id="last_name"
                                                                    :placeholder="$t('Last Name')"
                                                                    v-model="formData.last_name" required
                                                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focusBorder focus:shadow-md" />
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="-mx-3 flex flex-wrap">
                                                        <div class="w-full px-3 sm:w-1/2">
                                                            <div class="mb-5">
                                                                <label for="birthdate"
                                                                    class="mb-3 block text-base font-medium text-gray-600">
                                                                    {{ $t('Date of Birth') }}*
                                                                </label>
                                                                <input type="date" name="birthdate" id="birthdate"
                                                                    v-model="formData.birthdate" required
                                                                    @input="validateBirthdate"
                                                                    :class="{ 'border-[#ff0000] border-2': msg['birthdate'] }"
                                                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focusBorder focus:shadow-md" />
                                                                <small>{{ msg['birthdate'] }}</small>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="-mx-3 flex flex-wrap">
                                                        <div class="w-full px-3 sm:w-1/2">
                                                            <div class="mb-5">
                                                                <label for="email"
                                                                    class="mb-3 block text-base font-medium text-gray-600">
                                                                    {{ $t('Email') }}*
                                                                </label>
                                                                <input type="email" name="email" id="email"
                                                                    placeholder="Email" v-model="formData.email"
                                                                    @input="validateEmail" required
                                                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focusBorder focus:shadow-md"
                                                                    :class="{ 'border-[#ff0000] border-2': msg['email'] }" />
                                                                <small>{{ msg['email'] }}</small>
                                                            </div>
                                                        </div>
                                                        <div class="w-full px-3 sm:w-1/2">
                                                            <div class="mb-5">
                                                                <label for="phone"
                                                                    class="mb-3 block text-base font-medium text-gray-600">
                                                                    {{ $t('Phone') }}*
                                                                </label>
                                                                <VuePhoneNumberInput v-model="formData.phoneNumber"
                                                                    :required="true" :color="JSON.parse(client).main_color"
                                                                    validColor="#E0E0E0" :noExample="true"
                                                                    :error="formData.phoneNumber && !validatePhone()"
                                                                    :phone-number-blur="validatePhone" errorColor="#ff0000"
                                                                    ref="phoneNumberField" :countries-height="50"
                                                                    @update="updatePhoneNumberField($event)"
                                                                    style="height: 50px;" />
                                                                <small>{{ msg['phoneNumber'] }}</small>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="-mx-3 flex flex-wrap">
                                                        <div class="w-full px-3 sm:w-1/2">
                                                            <div class="mb-5">
                                                                <label for="company"
                                                                    class="mb-3 block text-base font-medium text-gray-600">
                                                                    {{ $t('Company name') }}
                                                                </label>
                                                                <input type="text" name="company" id="company"
                                                                    placeholder="Company name" v-model="formData.company"
                                                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focusBorder focus:shadow-md" />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="mb-5 mt-5 -mx-3 flex flex-wrap">
                                                        <div class="w-full px-3">
                                                            <label for="location"
                                                                class="font-bold mb-1 text-gray-700 block">{{
                                                                    $t('Location') }}</label>
                                                        </div>
                                                    </div>
                                                    <div class="-mx-3 flex flex-wrap">
                                                        <div class="w-full px-3 sm:w-1/2">
                                                            <div class="mb-5">
                                                                <label for="location"
                                                                    class="mb-3 block text-base font-medium text-gray-600">
                                                                    {{ $t('Streetname and housenumber') }}*
                                                                </label>
                                                                <input type="text" name="streetname" id="streetname"
                                                                    required placeholder="Streetname"
                                                                    v-model="formData.streetname"
                                                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focusBorder focus:shadow-md" />
                                                            </div>
                                                        </div>

                                                        <div class="w-full px-3 sm:w-1/2">
                                                            <div class="mb-5">
                                                                <label for="city"
                                                                    class="mb-3 block text-base font-medium text-gray-600">
                                                                    {{ $t('City / Town') }}*
                                                                </label>
                                                                <input type="text" name="city" id="city"
                                                                    :placeholder="$t('City / Town')" v-model="formData.city"
                                                                    required
                                                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focusBorder focus:shadow-md" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="-mx-3 flex flex-wrap">
                                                        <div class="w-full px-3 sm:w-1/2">
                                                            <div class="mb-5">
                                                                <label for="postcode"
                                                                    class="mb-3 block text-base font-medium text-gray-600">
                                                                    {{ $t('Postal Code') }}*
                                                                </label>
                                                                <input type="text" name="postcode" id="postcode" required
                                                                    placeholder="Postal code" v-model="formData.postcode"
                                                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focusBorder focus:shadow-md" />
                                                            </div>
                                                        </div>

                                                        <div class="w-full px-3 sm:w-1/2">
                                                            <div class="mb-5">
                                                                <label for="country"
                                                                    class="mb-3 block text-base font-medium text-gray-600">
                                                                    {{ $t('Country') }}*
                                                                </label>
                                                                <select name="country" id="country"
                                                                    v-model="formData.country" required
                                                                    class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focusBorder focus:shadow-md">
                                                                    <option value="">Select Country</option>
                                                                    <option
                                                                        v-for="country, key in JSON.parse(this.countries)"
                                                                        :value="key + ',' + country">{{ country }}
                                                                    </option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="-mx-3 flex flex-wrap mt-4 mb-4 md:mb-0">
                                                        <div class="w-full px-3">
                                                            <div class="flex items-center pl-4 border border-[#e0e0e0] text-gray-600 rounded-md ">
                                                                <input id="terms_conditons_check" @click="forceUpdate++" type="checkbox" ref="terms_conditons_check" name="terms_conditons_check" class="w-6 h-6 primary_color bg-gray-100 border-gray-300 rounded focusBorder">
                                                                <label for="terms_conditons_check" class="w-full py-4 ml-2 text-sm font-medium">{{$t("I agree with the")}} <a target="_blank" :href="JSON.parse(client).redirect + '/termsandconditions'" class="primary_color hover:underline">{{$t("terms and conditions")}}</a></label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- / Step Content -->
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <aside
                                class="md:col-span-4 mb-8 fixed translate-y-[100dvh] opacity-0 md:opacity-100 md:relative md:translate-y-0 transition-all
                    max-md:w-full max-md:z-30 max-md:bg-white max-md:!h-[100dvh] max-md:px-4 max-md:left-0 max-md:top-0"
                                :class="[showMobileMenu ? '!translate-y-[0] opacity-100 overflow-y-scroll pb-[120px] ' : 'translate-y-[100dvh]']">
                                <div class="w-full flex justify-end h-14 my-4 md:hidden">
                                    <button type="button" @click="showMobileMenu = false"
                                        class="text-gray-400 shadow-md bg-transparent justify-center hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-4 ml-auto inline-flex items-center w-14 h-14"><svg
                                            fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                                            class="w-5 h-5">
                                            <path fill-rule="evenodd"
                                                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                                                clip-rule="evenodd"></path>
                                        </svg></button>
                                </div>
                                <div class="sticky -top-[70px] animate-in fade-in"
                                    :class="{ '!-top-[140px]': getAmountOfRooms(setup) == 2, '!-top-[210px]': getAmountOfRooms(setup) >= 3 }">
                                    <div v-if="getAmountOfRooms(setup) > 1"
                                        class="absolute bottom-auto left-auto right-0 top-0 z-10 inline-block -translate-y-1/2 -translate-x-4 rotate-0 skew-x-0 skew-y-0 scale-x-100 scale-y-100 whitespace-nowrap rounded-full primary_background px-2.5 py-1 text-center align-baseline text-xs font-bold leading-none text-white">
                                        {{ getAmountOfRooms(setup) }} {{ $tc('room', getAmountOfRooms(setup)) }}
                                    </div>
                                    <div class=" w-full bg-gray-100 rounded-2xl mb-5 p-2 flex flex-col justify-center"
                                        :class="{ '!pb-0': getAmountOfRooms(setup) > 1, '!h-[140px]': getAmountOfRooms(setup) == 2, '!h-[210px] overflow-y-scroll !justify-start': getAmountOfRooms(setup) >= 3 }">
                                        <template v-for="room in JSON.parse(setup)"
                                            class="grid w-full gap-2 grid-flow-row-dense grid-cols-1 grid-rows-1"
                                            :class="{ '!grid-rows-2': getAmountOfRooms(setup) == 2, '!grid-rows-3': getAmountOfRooms(setup) >= 3 }">
                                            <div v-for="_ in parseInt(room.split('_')[1])" class="flex items-center h-full"
                                                :class="{ '!mb-2': getAmountOfRooms(setup) > 1 }">
                                                <vue-load-image
                                                    :key="'loadimage' + JSON.parse(rooms)[room.split('_')[0]].id"
                                                    class="h-full w-20 sm:block md:hidden lg:block"
                                                    :class="{ 'w-full': JSON.parse(rooms).length > 3 }">
                                                    <img v-if="JSON.parse(JSON.parse(rooms)[room.split('_')[0]].images).length > 0"
                                                        slot="image"
                                                        class="h-full w-full rounded-xl object-cover animate-in zoom-in"
                                                        @load="show = true"
                                                        :src="mipmap(Object.values(JSON.parse(JSON.parse(rooms)[room.split('_')[0]].images))[0].url, 100)"
                                                        :alt="i.name">
                                                    <img v-else slot="image"
                                                        class="h-full w-full rounded-xl object-cover animate-in zoom-in"
                                                        @load="show = true"
                                                        :src="mipmap(Object.values(JSON.parse(prop[JSON.parse(rooms)[room.split('_')[0]].propID].images)['hosted'])[0].url, 100)"
                                                        :alt="JSON.parse(rooms)[room.split('_')[0]].name">
                                                    <div slot="preloader"
                                                        class="h-full w-full rounded-xl object-cover bg-gray-300 animate-pulse flex justify-center">
                                                        <svg class="w-12 text-gray-200" xmlns="http://www.w3.org/2000/svg"
                                                            aria-hidden="true" fill="currentColor" viewBox="0 0 640 512">
                                                            <path
                                                                d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
                                                        </svg>
                                                    </div>
                                                </vue-load-image>
                                                <div class="ml-2 leading-5 flex w-full justify-between">
                                                    <div class="flex flex-col">
                                                        <span class="font-semibold leading-5">
                                                            {{ JSON.parse(rooms)[room.split('_')[0]].name }}
                                                        </span>
                                                        <span class="text-xs">
                                                            {{ prop[JSON.parse(rooms)[room.split('_')[0]].propID].city }},
                                                            {{
                                                                prop[JSON.parse(rooms)[room.split('_')[0]].propID].country }}
                                                        </span>
                                                    </div>
                                                    <div class="flex flex-col justify-center items-center"
                                                        :set="numAdult = parseInt(room.split('_')[2].split(',')[0])">
                                                        <div class="flex justify-between text-xs items-center">{{ numAdult
                                                        }}x
                                                            <div class="ml-2 flex min-w-[10px]">
                                                                <img class="w-[10px]"
                                                                    :src="currentUrl + '/images/icons/person.svg'">
                                                                <img class="-ml-[10px] w-[10px]" v-for=" i  in  numAdult "
                                                                    v-if="i > 1"
                                                                    :style="'opacity: calc((50% / ' + numAdult + ') * ' + numAdult + ') ;'"
                                                                    :src="currentUrl + '/images/icons/person.svg'">
                                                            </div>
                                                        </div>
                                                        <div v-if="parseInt(room.split('_')[2].split(',')[1]) > 0"
                                                            :set="numChildren = parseInt(room.split('_')[2].split(',')[1])"
                                                            class="flex justify-between text-xs items-center mt-[5px]">
                                                            {{ numChildren }}x
                                                            <div class="ml-2 flex">
                                                                <img class="w-[10px] h-[11px]"
                                                                    :src="currentUrl + '/images/icons/child.svg'">
                                                                <img class="-ml-[10px] w-[10px] h-[11px]"
                                                                    v-for=" i  in  numChildren " v-if="i > 1"
                                                                    :style="'opacity: calc((50% / ' + numChildren + ') * ' + numChildren + ') ;'"
                                                                    :src="currentUrl + '/images/icons/child.svg'">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>

                                    <div v-if="Object.keys(prop).length > 1" :set="maxDistance = getPropDistance()">
                                        <div class="bg-gray-50 text-center mb-5 border border-gray-300 text-gray-900 rounded-lg block w-full p-2.5 text-xs"
                                            :class="[maxDistance > 3 ? '!bg-red-100 !border-red-400 !text-red-700' : maxDistance < 1 ? '!bg-green-100 !border-green-400 !text-green-700' : '']">
                                            {{ $t('Distance between properties: ') }}
                                            <template v-if="maxDistance >= 1">{{ parseInt(maxDistance) }} {{ $t('km')
                                            }}<span class="text-xs" v-if="maxDistance > 10">!</span></template>
                                            <template v-else>{{ maxDistance * 1000 }} {{ $t('m') }}</template>
                                        </div>
                                    </div>

                                    <div v-if="sessionend"
                                        class="relative mx-auto bg-white border border-gray-300 text-gray-900 rounded-xl mb-5 inline-flex items-center w-full py-2">
                                        <div class="inline-flex items-center justify-center overflow-hidden rounded-full">
                                            <svg class="w-10 h-10">
                                                <circle class="text-gray-300" stroke-width="5" stroke="currentColor"
                                                    fill="transparent" r="10" cx="20" cy="20" />
                                                <circle class="primary_color" stroke-width="5"
                                                    :stroke-dasharray="circumference"
                                                    :stroke-dashoffset="circumference - timerCountValue / (60 * block_time) * circumference"
                                                    stroke-linecap="round" stroke="currentColor" fill="transparent" r="10"
                                                    cx="20" cy="20" />
                                            </svg>
                                        </div>
                                        <small class="leading-4 text-xs">Booking reserved for <br />
                                            <span class="text-xs" v-if="Math.floor(timerCountValue / 60) > 0">{{
                                                Math.floor(timerCountValue /
                                                    60)
                                            }} minutes and </span>{{ Math.floor(timerCountValue % 60) }} seconds</small>
                                    </div>

                                    <div class="grid justify-center grid-cols-1 gap-6 mb-5">
                                        <div class="flex items-center flex-col sm:flex-row md:flex-col lg:flex-row">
                                            <div class="relative w-full" :set="checkin = this.checkin">
                                                <div
                                                    class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                                    <svg aria-hidden="true" class="w-5 h-5 text-gray-500"
                                                        fill="currentColor" viewBox="0 0 20 20"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd"
                                                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                                            clip-rule="evenodd"></path>
                                                    </svg>
                                                </div>
                                                <input name="checkin" type="text"
                                                    class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full pl-10 p-2.5 nofocus"
                                                    :value="formatDate(checkin)" readonly>
                                            </div>
                                            <span class="mx-4 text-gray-500">to</span>
                                            <div class="relative w-full" :set="checkout = this.checkout">
                                                <div
                                                    class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                                    <svg aria-hidden="true" class="w-5 h-5 text-gray-500"
                                                        fill="currentColor" viewBox="0 0 20 20"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path fill-rule="evenodd"
                                                            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                                                            clip-rule="evenodd"></path>
                                                    </svg>
                                                </div>
                                                <input name="checkout" type="text"
                                                    class="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg block w-full pl-10 p-2.5 nofocus"
                                                    :value="formatDate(checkout)" readonly>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="calculatedTotal" class="w-full mb-0 overflow-hidden">
                                        <div class="relative mx-auto bg-gray-100 rounded-xl">
                                            <div class="w-full mb-0 overflow-hidden">
                                                <div class="relative mx-auto bg-gray-100 rounded-xl">
                                                    <div class="pt-1 px-4 flex justify-between">
                                                        <div class="relative pt-4 pb-4 overflow-hidden flex">
                                                            <span
                                                                class="block text-4xl font-bold text-gray flex justify-end flex-col">
                                                                {{ toCurrency(calculatedTotal) }}
                                                            </span>
                                                            <div v-if="fromPrice > calculatedTotal"
                                                                class="flex flex-col text-sm ml-3 primary_color ">
                                                                <span class="line-through leading-6"> {{
                                                                    toCurrency(fromPrice) }}</span>
                                                                <span class="leading-3 text-xs">
                                                                    {{ Math.round(multiplier)}}% 
                                                                    {{ $t('discount') }}!
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="calc_deposit">
                                                        <div class="h-8 relative">
                                                            <div
                                                                class="absolute left-0 top-1/2 transform -translate-y-1/2 w-full">
                                                                <div class="w-full border-b-8 border-dotted border-white">
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="absolute top-0 left-0 transform -translate-x-1/2 w-8 h-8 bg-white rounded-full">
                                                            </div>
                                                            <div
                                                                class="absolute top-0 right-0 transform translate-x-1/2 w-8 h-8 bg-white rounded-full">
                                                            </div>
                                                        </div>

                                                        <div class="px-4 flex justify-between">
                                                            <div
                                                                class="relative overflow-hidden text-gray w-full gap-2 text-center">
                                                                <span class="block text-sm"> {{ toCurrency(calc_deposit) }}
                                                                    {{
                                                                        $t('refundable deposit included') }}</span>
                                                            </div>
                                                        </div>


                                                        <div class="h-8 mb-3 relative">
                                                            <div
                                                                class="absolute left-0 top-1/2 transform -translate-y-1/2 w-full">
                                                                <div class="w-full border-b-8 border-dotted border-white">
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="absolute top-0 left-0 transform -translate-x-1/2 w-8 h-8 bg-white rounded-full">
                                                            </div>
                                                            <div
                                                                class="absolute top-0 right-0 transform translate-x-1/2 w-8 h-8 bg-white rounded-full">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-else-if="totalprice">
                                                        <div class="h-8 mb-3 relative">
                                                            <div
                                                                class="absolute left-0 top-1/2 transform -translate-y-1/2 w-full">
                                                                <div class="w-full border-b-8 border-dotted border-white">
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="absolute top-0 left-0 transform -translate-x-1/2 w-8 h-8 bg-white rounded-full">
                                                            </div>
                                                            <div
                                                                class="absolute top-0 right-0 transform translate-x-1/2 w-8 h-8 bg-white rounded-full">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-else class="mb-5"></div>


                                                    <div v-if="computed_upsells" class="px-6 pb-4 space-y-3">

                                                        <ol v-for="(upsellroomblock, key) in computed_upsells"
                                                            class="list-inside "
                                                            :class="[computed_upsells.length > 1 ? 'p-3 py-2 border rounded-lg' : '']">
                                                            <app-accordion>
                                                                <template v-slot:title>
                                                                    <small class="leading-5">{{
                                                                        JSON.parse(rooms)[Object.keys(upsellroomblock)[0]].name
                                                                    }}</small>
                                                                </template>
                                                                <template v-slot:content>
                                                                    <template v-for="upsellroom in upsellroomblock">
                                                                        <li class="flex items-center p-1 justify-between">
                                                                            <span class="leading-4 text-xs">
                                                                                {{ $t('Room price ') }}
                                                                            </span>
                                                                            <span class="leading-4 text-xs">{{
                                                                                toCurrency(JSON.parse(prices).find(
                                                                                    x => x.roomID ==
                                                                                        Object.keys(upsellroomblock)[0]).originalRoomPrice)
                                                                            }}</span>
                                                                        </li>
                                                                        <li v-if="fromPrice > calculatedTotal && JSON.parse(prices).find(x => x.roomID == Object.keys(upsellroomblock)[0]).discount && JSON.parse(prices).find(x => x.roomID == Object.keys(upsellroomblock)[0]).discount > 0"
                                                                            class="flex items-center p-1 rounded justify-between primary_color border primaryBorder bg_primary_color_lightest">
                                                                            <span class="leading-4 text-xs">
                                                                                {{ $t('discount') }}!
                                                                            </span>
                                                                            <span class="leading-4 text-xs">- {{
                                                                                toCurrency(JSON.parse(prices).find(
                                                                                    x => x.roomID ==
                                                                                        Object.keys(upsellroomblock)[0]).discountAmount)
                                                                            }}</span>
                                                                        </li>
                                                                        <template v-for="(upsell, key2) in upsellroom">
                                                                            <template
                                                                                v-if="upsell.type == 2 || upsell.type == 4 || upsell.type == 6 || upsell.type == 7 || upsell.type == 8">
                                                                                <li
                                                                                    class="flex items-center p-1 justify-between">
                                                                                    <span class="leading-4 text-xs">
                                                                                        {{ getUpsellNameWithoutMax(upsell.description.EN) }}
                                                                                        {{ upsell.unit == 1 ?
                                                                                            $t('per person') : upsell.unit == 2
                                                                                                ?
                                                                                                $t('per adult') :
                                                                                                upsell.unit == 3 ? $t('per child') :
                                                                                                    null }}
                                                                                        {{ upsell.period == 1 ? $t('daily')
                                                                                            :
                                                                                            upsell.period == 2 ? $t('weekly') :
                                                                                                upsell.unit == 4 ?
                                                                                                    $t('daily incl') : upsell.period ==
                                                                                                        3 ?
                                                                                                        $t('refundable') : null }}
                                                                                    </span>
                                                                                    <span class="leading-4 text-xs">{{
                                                                                        parseInt(upsell.totalPrice) != 0 ?
                                                                                        toCurrency(upsell.totalPrice) :
                                                                                        parseInt(upsell.price) != 0 ?
                                                                                            toCurrency(getUpsellTotalPrice(upsell,
                                                                                                Object.keys(upsellroomblock)[0])) :
                                                                                            $t('Free')
                                                                                    }}</span>
                                                                                </li>
                                                                            </template>
                                                                        </template>

                                                                        <template v-for="(upsell, key2) in upsellroom">
                                                                            <template
                                                                                v-if="upsell.type != 2 && upsell.type != 4 && upsell.type != 6 && upsell.type != 7 && upsell.type != 8 && upsell.check">
                                                                                <li
                                                                                    class="flex items-center p-1 justify-between">
                                                                                    <span class="leading-4 text-xs">
                                                                                        {{ getUpsellNameWithoutMax(upsell.description.EN) }}
                                                                                        {{ upsell.type == 3 ? upsell.amount
                                                                                            + 'x' :
                                                                                            null }}
                                                                                        {{ upsell.unit == 1 ?
                                                                                            $t('per person') : upsell.unit
                                                                                                == 2 ? $t('per adult') : upsell.unit
                                                                                                    == 3 ?
                                                                                                $t('per child') : null }}
                                                                                        {{ upsell.period == 1 ? $t('daily')
                                                                                            :
                                                                                            upsell.period == 2 ? $t('weekly') :
                                                                                                upsell.unit == 4 ?
                                                                                                    $t('daily incl') : upsell.period ==
                                                                                                        3 ?
                                                                                                        $t('refundable') : null }}
                                                                                    </span>
                                                                                    <span class="leading-4 text-xs">
                                                                                        {{
                                                                                            parseInt(upsell.totalPrice) != 0 ?
                                                                                            toCurrency(upsell.totalPrice) :
                                                                                            parseInt(upsell.price) != 0 ?
                                                                                                toCurrency(getUpsellTotalPrice(upsell,
                                                                                                    Object.keys(upsellroomblock)[0])) :
                                                                                                $t('Free')
                                                                                        }}
                                                                                    </span>
                                                                                </li>
                                                                            </template>
                                                                        </template>
                                                                    </template>
                                                                </template>
                                                            </app-accordion>
                                                        </ol>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex justify-between mt-4">
                                        <div class="w-full">
                                            <button v-show="!warning" v-if="!isShowError"
                                                @click="step == 2 && formValid ? submitBooking() : step++, forceUpdate++"
                                                class="w-full focus:outline-none border border-transparent py-2 px-5 rounded-lg shadow-sm pointer-events-none text-center text-white bg-gray-200 font-medium transition duration-300 opacity-50 cursor-not-allowed"
                                                :class="[ step < 2 || formValid ? '!opacity-100 hover:shadow-xl primary_background !cursor-pointer hover:scale-105 pointer-events-auto' : '' ]">
                                                <template v-if="computed_step == 1">
                                                    {{ $t('Next') }}
                                                </template>
                                                <template v-else-if="computed_step == 2">
                                                    {{ $t('Book now') }}
                                                </template>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="px1 flex flex-wrap gap-4 justify-center w-full mt-4">
                                        <div class="w-16 h-10 bg-white p-2 rounded-md">
                                            <svg-vue class="w-full h-full"
                                                icon="mastercard"></svg-vue>
                                        </div>
                                        <div class="w-16 h-10 bg-white p-2 rounded-md">
                                            <svg-vue class="w-full h-full"
                                                icon="visa2"></svg-vue>
                                        </div>
                                        <div class="w-16 h-10 bg-[#016fd0] p-2 py-0 rounded-md">
                                            <svg-vue class="w-full h-full"
                                                icon="americanexpress"></svg-vue>
                                        </div>

                                        <div class="w-16 h-10 bg-white p-2 rounded-md">
                                            <svg-vue class="w-full h-full"
                                                icon="ideal"></svg-vue>
                                        </div>
                                        <div class="w-16 h-10 bg-white p-2 rounded-md">
                                            <svg-vue class="w-full h-full"
                                                icon="PayPal"></svg-vue>
                                        </div>
                                        <div class="w-16 h-10 bg-white p-2 rounded-md">
                                            <svg-vue class="w-full h-full"
                                                icon="apple_pay"></svg-vue>
                                        </div>
                                        <div class="w-16 h-10 bg-white p-2 rounded-md">
                                            <svg-vue class="w-full h-full"
                                                icon="google_pay"></svg-vue>
                                        </div>
                                        <div class="w-16 h-10 bg-white p-2 rounded-md">
                                            <svg-vue class="w-full h-full"
                                                icon="Maestro"></svg-vue>
                                        </div>
                                    </div>

                                    <div class="px1 w-full mt-4 text-gray-400 text-xs text-center">
                                        {{$t('The website and mobile applications from client_name are developed and distributed by', {client: JSON.parse(client).name})}} <a href="https://boostmybookings.com" target="_blank" class="text-xs inline primary_color hover:underline">{{ $t('BoostmyBookings B.V.') }}</a>
                                    </div>
                                </div>
                            </aside>
                        </div>
                    </section>
                </div>
            </transition>
        </div>

        <div
            class="w-full h-[100px] bg-white drop-shadow-xl border-t z-30 fixed md:!hidden bottom-0 p-3 transition-all duration-300 translate-y-0 flex opacity-100">

            <div class="flex w-[60%]" @click="showMobileMenu = !showMobileMenu">
                <div class="h-full flex justify-center ml-1 mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 primary_color transition-all"
                        :class="{ 'rotate-180': showMobileMenu }" fill="currentColor"
                        viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                        <path
                            d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z" />
                    </svg>
                </div>
                <div class="primary_color h-full rounded-xl w-[90%] flex-auto flex flex-col justify-center mr-1">
                    <span class="block text-3xl font-bold justify-end flex-col">
                        {{ toCurrency(calculatedTotal) }}
                    </span>
                </div>
            </div>
            <button v-show="!warning" v-if="!isShowError"
                @click="step == 2 && formValid ? submitBooking() : step++, forceUpdate++"
                class="flex-auto ml-1 focus:outline-none border border-transparent py-2 px-5 rounded-xl shadow-md pointer-events-none text-center text-white bg-gray-200 font-medium transition duration-300 opacity-50 cursor-not-allowed"
                :class="{ '!opacity-100 hover:shadow-xl primary_background !cursor-pointer hover:scale-105 pointer-events-auto': step < 2 || formValid }">
                <template v-if="computed_step == 1">
                    {{ $t('Next') }}
                </template>
                <template v-else-if="computed_step == 2">
                    {{ $t('Book now') }}
                </template>
            </button>
        </div>
    </div>
</template>
<script>
var moment = require('moment');

import VueLoadImage from 'vue-load-image'
const formatter = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' })
import _ from 'lodash';
import RoomHelpers from "../roomhelpers";
import BookingHelpers from "../bookinghelpers";

import VueCookies from 'vue-cookies'

import AppAccordion from "./items/AppAccordion.vue";

import { StripeElementPayment } from '@vue-stripe/vue-stripe';

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {

    components: {
        'vue-load-image': VueLoadImage, AppAccordion, StripeElementPayment, VuePhoneNumberInput
    },
    props: ['client', 'client_logo', 'prices', 'totalprice', 'properties', 'rooms', 'num_adult', 'bookingids',
        'setup', 'num_children', 'checkin', 'checkout', 'countries', 'sessionend', 'block_time', 'stripe_key', 'warning'],
    data() {
        if (VueCookies.get('upsells')) {
            var selectedUpsells = VueCookies.get('upsells');
        } else {
            var selectedUpsells = [];
        }

        if (VueCookies.get('formData')) {
            var formData = VueCookies.get('formData')
        } else {
            var formData = {
                first_name: '',
                last_name: '',
                birthdate: '',
                email: '',
                phoneNumber: '',
                company: '',
                streetname: '',
                city: '',
                postcode: '',
                country: '',
            }
        }

        var room_setup = []
        for (var i in JSON.parse(this.setup)) {
            for (var j in JSON.parse(this.setup)[i].split("_")[2].split("-")) {
                room_setup.push(JSON.parse(this.setup)[i].split("_")[2].split("-")[j]);
            }
        }

        return {
            step: 1,
            passwordStrengthText: '',
            currentUrl: '',
            togglePassword: false,
            discount: "",
            selectedUpsell: selectedUpsells,
            formData: formData,
            password: '',
            price: JSON.parse(this.prices),
            multiplier: 0,
            upsells: [],
            showMobileMenu: false,
            darkerColor: '',
            optionalUpsells: [],
            deposits: [],
            msg: [],
            calculatedTotal: 0,
            fromPrice: 0,
            basePrice: 0,
            prop: JSON.parse(this.properties),
            PaymentMetaData: null,
            confirmBooking: false,
            validUntil: null,
            loadingScreen: true,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            circumference: 10 * 2 * Math.PI,
            timerCount: null,
            timerCountValue: null,
            nrDays: Math.abs(moment(this.checkout).diff(moment(this.checkin), 'days')),
            bookingType: [],
            isShowError: false,
            upsellRefresh: 0,
            forceUpdate: 0,
            hideUpsells: false,
            loadingStripe: 0,
            stripeLoading: true,
            stripeError: false,
            createStripeOptions: {
                layout: {
                    type: 'tabs',
                    defaultCollapsed: false,
                    radios: false,
                    spacedAccordionItems: true
                },
                fields: {
                    billingDetails: {
                        name: 'never'
                    }
                }
            },
            elementsOptions: {
                appearance: {
                    theme: 'stripe',
                    variables: {
                        colorPrimary: JSON.parse(this.client).main_color,
                    },
                }, // appearance options
            },
            confirmParams: {
            },
        }
    },
    methods: {
        ...RoomHelpers,
        ...BookingHelpers,
        toCurrency(value) {
            return formatter.format(value)
        },
        check() {
            this.checked = !this.checked;
        },
        getMaxUpsellAmount(upsell) {
            if (upsell.match("\(max:.*\)")) {
                var number = upsell.split("(max:")[1].split(")")[0]
                return parseInt(number);
            }
             else {
                return 4;
            }
        },
        getUpsellNameWithoutMax(name) {
            return name.split("(max:")[0]
        },
        checkPasswordStrength() {
            var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
            var mediumRegex = new RegExp(
                "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");

            let value = this.password;

            if (strongRegex.test(value)) {
                this.passwordStrengthText = "Strong password";
            } else if (mediumRegex.test(value)) {
                this.passwordStrengthText = "Could be stronger";
            } else {
                this.passwordStrengthText = "Too weak";
            }
        },
        hasOptionalUpsells(upsells) {
            var hasOptionalUpsells = false;
            for (var idx in upsells) {
                for (var idx2 in upsells[idx]) {
                    upsells[idx][idx2].type == 1 || upsells[idx][idx2].type == 3 || upsells[idx][idx2].type == 5 ? hasOptionalUpsells = true : null;
                }
            }
            return hasOptionalUpsells
        },
        reload() {
            location.reload();
        },
        setupPaymentMeta() {
            var paymentData = this.formData;
            paymentData.source = JSON.parse(this.client).name
            paymentData.id = this.bookingids
            paymentData.phone = this.$refs.phoneNumberField ? this.$refs.phoneNumberField.formatInternational : ''
            paymentData.checkin = this.checkin
            paymentData.checkout = this.checkout
            paymentData.validUntil = this.validUntil
            paymentData.setup = this.setup
            paymentData.clientID = JSON.parse(this.client).id
            paymentData.rooms = JSON.stringify(this.getRoomNames(this.setup))
            this.PaymentMetaData = paymentData
        },
        submitBooking() {
            if (this.getThirdStepName() == this.$t('Payment')) {
                this.loadingScreen = true
                const body = JSON.stringify({
                    setup: this.setup,
                    data: this.PaymentMetaData,
                    amount: this.calculatedTotal,
                    deposit: this.calc_deposit,
                    upsells: this.selectedUpsell,
                    checkin: this.checkin,
                    checkout: this.checkout,
                    clientID: JSON.parse(this.client).id,
                    _token: this.csrf
                });

                fetch(route(this.$i18n.locale+'.booking.submitRequest', JSON.parse(this.client).id), {
                    method: 'post', // Default is 'get'
                    body: body,
                    mode: 'cors',
                    headers: new Headers({
                        'Content-Type': 'application/json; charset=UTF-8'
                    })
                    })
                    .then(response => {
                        if (response.status == 202) {
                            return response.json();
                        } else if (response.status == 300) {
                            var newUrl = this.currentUrl + "/book/"+JSON.parse(this.client).id;
                            window.location.href = newUrl;
                            throw new Error('items not available');
                        } else {
                            this.loadingScreen = false;
                            Vue.$toast.error('Something went wrong');
                            throw new Error('Something went wrong');
                        }
                    })
                    .then(text => {
                        var newUrl = this.currentUrl + "/book/"+JSON.parse(this.client).id+"/payment?"
                        newUrl += text;
                        var setupstring = JSON.parse(this.setup).join(".")
                        newUrl += "&setup=" + setupstring;
                        window.location.href = newUrl;
                    })
            } else {
                this.loadingScreen = true
                const xhr = new XMLHttpRequest();
                xhr.open("POST", route(this.$i18n.locale+'.booking.submitRequest', JSON.parse(this.client).id));
                xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
                const body = JSON.stringify({
                    setup: this.setup,
                    data: this.PaymentMetaData,
                    amount: this.calculatedTotal,
                    deposit: this.calc_deposit,
                    upsells: this.selectedUpsell,
                    checkin: this.checkin,
                    checkout: this.checkout,
                    clientID: JSON.parse(this.client).id,
                    _token: this.csrf
                });
                xhr.onload = () => {
                    if (xhr.readyState == 4 && xhr.status == 202) {
                        var newUrl = this.currentUrl + "/book/"+JSON.parse(this.client).id+"/result?"
                        newUrl += "&checkin=" + moment(this.checkin).format('YYYY-MM-DD')
                        newUrl += "&checkout=" + moment(this.checkout).format('YYYY-MM-DD')
                        newUrl += "&numAdult=" + this.num_adult
                        newUrl += "&numChildren=" + this.num_children
                        newUrl += "&bookingIDs=" + JSON.parse(this.PaymentMetaData.id).join(",")
                        var setupstring = this.setup;
                        if (typeof setupstring == 'object' || typeof setupstring == 'array') {
                            setupstring = setupstring.join(".")
                        }
                        newUrl += "&setup=" + setupstring;
                        window.location.href = newUrl;
                    } else {
                        console.log(`Error: ${xhr.status}`);
                        this.loadingScreen = false
                        this.isShowError = true;
                    }
                };
                xhr.send(body);
            }
        },
        getBookingType() {
            var bookingType = [];
            for (var index in this.prop) {
                if (!bookingType.includes(JSON.parse(this.prop[index].bookingRules).bookingType)) {
                    bookingType.push(JSON.parse(this.prop[index].bookingRules).bookingType)
                }
            }
            this.bookingType = bookingType;
        },
        getThirdStepName() {
            if (this.bookingType.length == 1) {
                if (this.bookingType[0].slice(0, 7) == 'confirm') {
                    this.confirmBooking = true;
                    return this.$t('Payment')
                }
            }
            return this.$t('Request')
        },
        updatePhoneNumberField($event) {
            if (this.formData.country == '') {
                this.formData.country = $event.countryCode + "," + JSON.parse(this.countries)[$event.countryCode]
            }
        }

    },
    watch: {
        '$route'() {
            this.loadingScreen = false;
        },
        step: {
            handler(value) {
                if (value != 3 || this.formValid) {
                    VueCookies.set('step', value)
                } else if (value == 3) {
                    if (this.calculateTotal != 0 && this.getThirdStepName() == this.$t('Payment')) {
                        this.generatePaymentIntent();
                    }
                }
            }
        },
        calculateTotal: {
            handler() {
                if (this.step == 3 && this.getThirdStepName() == this.$t('Payment')) {
                    this.generatePaymentIntent();
                }
            }
        },
        formData: {
            handler: _.debounce(function (v) {
                VueCookies.set('formData', v)
                this.setupPaymentMeta();
            }, 1000),
            deep: true
        },
        upsells: {
            handler(newVal, oldVal) {
                this.calculatedTotal = Number(this.totalprice)

                var totalDiscountAmount = 0
                JSON.parse(this.prices).forEach((item, index2) => {
                    totalDiscountAmount += Number(item.discountAmount);
                })

                var fromPrice = 0;

                newVal.forEach(item2 => {
                    for (var i in item2[Object.keys(item2)[0]]) {
                        if (item2[Object.keys(item2)[0]][i].check) {
                            if (item2[Object.keys(item2)[0]][i].type == 3) {
                                var newAddition = Number(item2[Object.keys(item2)[0]][i].price) * Number(item2[Object.keys(item2)[0]][i].amount)
                                this.calculatedTotal += newAddition
                                this.fromPrice += newAddition
                            } else if (item2[Object.keys(item2)[0]][i].type == 1) {
                                this.calculatedTotal += Number(item2[Object.keys(item2)[0]][i].totalPrice)
                                this.fromPrice += Number(item2[Object.keys(item2)[0]][i].totalPrice)
                            }
                        }
                    }
                })

                fromPrice += this.calculatedTotal + totalDiscountAmount;

                var multiplierAmount = ((fromPrice - this.totalprice) / fromPrice) * 100
                this.multiplier = multiplierAmount;
                this.fromPrice = fromPrice;
            },
            deep: true
        }
    },
    created() {
        VueCookies.set('reset', false);
        var self = this;
        window.addEventListener("pageshow", function () {
            self.loadingScreen = false;
        }, false);
        this.darkerColor = this.getDarkerColor();
        this.getUpsells();
        this.getBookingType();
        this.formValid;
        if (VueCookies.get('step') && (VueCookies.get('step') != 3 || this.formValid)) {
            this.step = VueCookies.get('step')
            this.forceUpdate++;
        }
        this.setupPaymentMeta();

        setTimeout(() => {
            this.forceUpdate++;
        }, 600);

    },
    computed: {
        computed_upsells: function () {
            this.upsellRefresh;
            return this.upsells
        },
        computed_step: function () {
            if (this.warning) {
                return 1;
            }
            if (this.step == 3 && this.formValid && this.getThirdStepName() == this.$t('Payment')) {
                this.generatePaymentIntent();
            }
            this.step;
            return this.step;
        },
        calc_deposit: function () {
            var price = 0

            for (var deposits of this.deposits) {
                for (var i in deposits) {
                    if (typeof deposits[i] == 'object') {
                        price += Number(deposits[i]['totalPrice']);
                    }
                }
            }
            return price;
        },
        elementOptionsComp: function () {
            this.loadingStripe
            return this.elementsOptions
        },
        formValid() {
            this.forceUpdate;
            this.validateBirthdate()
            this.validateEmail()
            if (this.$refs.terms_conditons_check && this.$refs.terms_conditons_check.checked == true) {
                if (
                    !this.formData.first_name ||
                    !this.formData.last_name ||
                    !this.formData.birthdate ||
                    !this.formData.email ||
                    !this.formData.phoneNumber ||
                    !this.formData.streetname ||
                    !this.formData.city ||
                    !this.formData.postcode ||
                    !this.formData.country ||
                    !this.validateBirthdate() ||
                    !this.validateEmail() ||
                    (this.$refs.phoneNumberField && !this.validatePhone())) {
                    return 0;
                } else {
                    return 1;
                }
            } else {
                return 0;
            }
        }
    },
    mounted() {
        this.$nextTick(function () {
            this.loadingScreen = false;
        })
    },
};
</script>